import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/announcementBarApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import TravelerTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/TravelerTemplateWidget";
import ProductSellerTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/ProductSellerTemplateWidget";
import PhotoShootsTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/PhotoShootsTemplateWidget";
import WeddingPhotogTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/WeddingPhotogTemplateWidget"; 
import InteriorDesignerTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/InteriorDesignerTemplateWidget";
import ProductPhotoTemplateWidget from "../../../../components/Apps/PhotoGallery/Template/ProductPhotoTemplateWidget";

//Import Tabs
import PhotosTab from "../../../../components/Apps/PhotoGallery/PhotosTab";
import LayoutTab from "../../../../components/Apps/PhotoGallery/LayoutTab";
import StyleTab from "../../../../components/Apps/PhotoGallery/StyleTab";
import SettingTab from "../../../../components/Apps/PhotoGallery/SettingTab";

export default function CreatePhotoGallery() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Photos");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Traveler_Temp");
    const [selectedLayout, setSelectedLayout] = useState("traveler_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("traveler.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Photo Gallery");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [photoGalleryTabData, setPhotoGalleryTabData] = useState({
        is_website_frontend: "",  
        testing: "",     
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let testing = "";
        
            switch (activeTemplateSection) {
                case "Traveler_Temp":
                    testing = "";
                    break;
                case "Product_Seller_Temp":
                    testing = "";
                    break;
                case "Photo_Shoots_Temp":
                    testing = "";
                    break;
                case "Wedding_Photographer_Temp":
                    testing = "";
                    break;
                case "Interior_Designer_Temp":
                    testing = "";
                    break;
                case "Product_Photographer_Temp":
                    testing = "";
                    break;
                default:
                    testing = "";
            }
        
            // Update setNumberCounterTabData state with the data
            setPhotoGalleryTabData((prevData) => ({
                ...prevData,
                testing: testing,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updatePhotoGalleryTabData = (key, value) => {
        setPhotoGalleryTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Photos", icon: "photos.png", label: "Photos" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Settings", icon: "setting.png", label: "Settings" },
      { key: "Style", icon: "style.png", label: "Style" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(photoGalleryTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Photo_Gallery",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/photo-gallery');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Photo Gallery" app_type="Photo_Gallery" app_slug="photo-gallery"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Traveler_Temp" data-layout_type="traveler_layout" data-template_image="traveler.png" checked={activeTemplateSection === "Traveler_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/traveler.png`} alt="traveler" />
                                    </div> 
                                    <div className="content_sub">Traveler</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Product_Seller_Temp" data-layout_type="product_seller_layout" data-template_image="product-seller.png" checked={activeTemplateSection === "Product_Seller_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/product-seller.png`} alt="product-seller" />
                                    </div>
                                    <div className="content_sub">Product Seller</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Photo_Shoots_Temp" data-layout_type="photo_shoots_layout" data-template_image="photo-shoots.png" checked={activeTemplateSection === "Photo_Shoots_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/photo-shoots.png`} alt="photo-shoots" />
                                    </div>
                                    <div className="content_sub">Photo Shoots</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Wedding_Photographer_Temp" data-layout_type="wedding_photographer_layout" data-template_image="wedding-photographer.png" checked={activeTemplateSection === "Wedding_Photographer_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/wedding-photographer.png`} alt="wedding-photographer" />
                                    </div>
                                    <div className="content_sub">Wedding Photographer</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Interior_Designer_Temp" data-layout_type="interior_designer_layout"  data-template_image="interior-designer.png" checked={activeTemplateSection === "Interior_Designer_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/interior-designer.png`} alt="interior-designer" />
                                    </div>
                                    <div className="content_sub">Interior Designer</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Product_Photographer_Temp" data-layout_type="product_photographer_layout" data-template_image="product-photographer.png" checked={activeTemplateSection === "Product_Photographer_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/photo-gallery/templates/product-photographer.png`} alt="product-photographer" />
                                    </div>
                                    <div className="content_sub">Product Photographer</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/photo-gallery/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Photos" && (
                              <PhotosTab updatePhotoGalleryTabData={updatePhotoGalleryTabData} photoGalleryTabData={photoGalleryTabData} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updatePhotoGalleryTabData={updatePhotoGalleryTabData} photoGalleryTabData={photoGalleryTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updatePhotoGalleryTabData={updatePhotoGalleryTabData} photoGalleryTabData={photoGalleryTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updatePhotoGalleryTabData={updatePhotoGalleryTabData} photoGalleryTabData={photoGalleryTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/photo-gallery"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/photo-gallery/photo-gallery.svg`} alt="photo-gallery"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/photo-gallery/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/photo-gallery" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Photo Gallery <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Traveler_Temp" && (
                      <TravelerTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}

                    {activeTemplateSection === "Product_Seller_Temp" && (
                      <ProductSellerTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}

                    {activeTemplateSection === "Photo_Shoots_Temp" && (
                      <PhotoShootsTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}

                    {activeTemplateSection === "Wedding_Photographer_Temp" && (
                      <WeddingPhotogTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}

                    {activeTemplateSection === "Interior_Designer_Temp" && (
                      <InteriorDesignerTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}

                    {activeTemplateSection === "Product_Photographer_Temp" && (
                      <ProductPhotoTemplateWidget photoGalleryTabData={photoGalleryTabData} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 